import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterContentInit, AfterViewInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { GlobalConstants } from '../../constants/global-constants';

@Component({
  selector: 'app-rat-input',
  templateUrl: './rat-input.component.html',
  styleUrls: ['./rat-input.component.css']
})
export class RatInputComponent implements OnInit, AfterViewInit {

  @Input() question!: any;
  @Input() eachControl!: any;
  @Input() controlIndex!: number;
  @Input() form!: FormGroup;
  @Output() inputChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() isSubmittedEvent!: Observable<void>;
  @ViewChild('userinputbox') userinputbox!: ElementRef;
  isArabic!: boolean;
  isValid!: boolean;
  controlValue: any;
  isDisabled: any;
  patternValid!: boolean;
  slashValid!: boolean;
  allowdKeys = [];
  isChecker: any;
  textCharCount: any = 0;

  constructor(private storageService: StorageService, private activateRoute: ActivatedRoute) {

  }
  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    this.isDisabled = this.eachControl.isDisabled;
    // console.log('validation check control: ',this.eachControl);
    // console.log('test: ',this.question);
    if (this.eachControl?.value == null || this.eachControl?.value == undefined || this.eachControl?.value == '' ||
      this.eachControl?.value == 'null' ||
      // this.eachControl?.value == 'N/A'
      this.eachControl?.value == GlobalConstants.BYPASS_QUESTION_RESPONSE_TEXT
    ) {
      this.controlValue = '';
    } else {
      this.controlValue = this.eachControl?.value;
    }
    this.textCharCount = this.controlValue?.length;

    // console.log('input ques: --- ', this.question.quesId + '_id_' + this.controlIndex, ' ans: --- ', this.eachControl?.value);
    this.form.controls[this.question.quesId + '_id_' + this.controlIndex].setValue(this.controlValue);
    this.isSubmittedEvent.subscribe(() => {
      this.setValidation(this.controlValue, this.question.quesId + '_id_' + this.controlIndex);
    });
  }
  ngAfterViewInit(): void {
    this.autosizeTextBox();
  }
  getControl(): (AbstractControl | null) {
    return this.form.controls[this.question.quesId + '_id_' + this.controlIndex];
  }
  inputChange(evt: any, parentQuesId: any) {
    this.controlValue = evt.target.value;
    this.setValidation(evt.target.value, parentQuesId);
  }
  handleKeyDown(evt: any) {
    this.textCharCount = evt.target.value?.length;
    this.autosizeTextBox();
  }
  autosizeTextBox() {
    if (this.userinputbox.nativeElement.scrollHeight <= 200) {
      this.userinputbox.nativeElement.style.height = 'auto';
      this.userinputbox.nativeElement.style.height = `${this.userinputbox.nativeElement.scrollHeight}px`;
    }
    else if (this.userinputbox.nativeElement.scrollHeight > 200) {
      this.userinputbox.nativeElement.style.height = 'auto';
      this.userinputbox.nativeElement.style.height = `200px`;
    }
  }
  setValidation(selectedVal: any, parentQuesId: any) {
    // console.log(this.isValid);
    if (selectedVal == '') {
      this.form.controls[this.question.quesId + '_id_' + this.controlIndex].setErrors({ 'required': true });
      this.form.controls[this.question.quesId + '_id_' + this.controlIndex].markAsTouched();
      this.isValid = false;
    } else {
      this.isValid = true;
    }

    if (this.eachControl?.validation?.numeric?.value || this.eachControl?.validation?.alphanumeric?.value) {
      this.checkCustomValidation();
      if (this.isValid && this.patternValid) {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    }
    let finalVal = selectedVal;
    // if(this.controlValue.includes(';') || this.controlValue.includes('\\')) {
    if (this.controlValue.includes(';')) {
      // finalVal = selectedVal.replace(/[\\|;]/g, '');
      finalVal = selectedVal.replace(/[;]/g, '');
      this.controlValue = finalVal;
      this.form.controls[this.question.quesId + '_id_' + this.controlIndex].setValue(this.controlValue);
    }
    // if (this.controlValue == 'N/A') {
    //   this.controlValue = 'NA';
    if (this.controlValue == GlobalConstants.BYPASS_QUESTION_RESPONSE_TEXT) {
      this.controlValue = GlobalConstants.BYPASS_QUESTION_RESPONSE_TEXT;
      this.form.controls[this.question.quesId + '_id_' + this.controlIndex].setValue(this.controlValue);
    }

    this.inputChanged.emit({ parentQuesId, parentQuesValue: finalVal, quesValid: this.isValid, index: this.controlIndex });
  }
  checkCustomValidation() {
    if (this.eachControl.validation.numeric) {
      let regex = new RegExp("^([0-9]*)$");
      if (regex.test(this.controlValue)) {
        this.patternValid = true;
      }
    }
    else if (this.eachControl.validation.alphanumeric) {
      let regex = new RegExp("^([a-zA-Z0-9 ]+)$");
      if (regex.test(this.controlValue)) {
        this.patternValid = true;
      }
    }
  }

  checkBackslashEnter(event: any) {
    // console.log(event);
    // if (event.key == '\\' || event.which == 220 || event.key == ';' || event.which == 186 || event.which == '13' || event.key == 'Enter') {
    if (event.key == ';' || event.which == 186 || event.which == '13' || event.key == 'Enter') {
      event.preventDefault();
      return;
    }
  }
}
